import { mapActions, mapGetters } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import popupPageModeMixin from '@/mixins/popupPageModeMixin';
import { MODALS } from '@/components/app/app-modals/app-modals';
import userAgentMixin from '@/mixins/userAgent';

const CAPTCHA_FIELD = 'g-recaptcha-response';

export default {
  mixins: [
    formMixin,
    popupPageModeMixin,
    userAgentMixin,
  ],
  props: {
    email: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      // login attempt counter used to rerender captcha on failed login
      attempt: 1,
      fieldTypePassword: 'password',
      fields: {
        email: this.email,
        password: '',
        rememberMe: true,
        captcha: '',
      },
      timeout: null,
    };
  },
  validations: {
    fields: {
      email: validators.emailNoMessage,
      password: validators.requiredNoMessage,
      captcha: validators.captcha,
    },
  },
  computed: {
    ...mapGetters('user', ['isUserRestricted']),
    loginButtonDisabled() {
      return this.invalidOrDisabled || !this.fields.captcha;
    }
  },
  methods: {
    ...mapActions('user', ['login', 'setUseDisqus', 'loginDisqus']),
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentPopupOptions']),
    ...mapActions('profile', ['setProfileStatus']),
    showPassword() {
      this.fieldTypePassword = (this.fieldTypePassword === 'password') ? 'text' : 'password';
    },
    onForgotten() {
      if (this.isPage) {
        this.$router.push({ name: 'account-password-forgotten' });
      } else {
        this.setCurrentPopup(MODALS.FORGOTTEN);
      }
    },
    getRedirectPath() {
      if (this.$router.currentRoute.query.redirect) return this.$router.currentRoute.query.redirect;
      if (this.$router.currentRoute.name === 'home' || this.isPage) return { name: 'portfolio' };
      return null;
    },
    triggerRedirect(redirect) {
      this.$router.push(redirect);
      if (this.isIos) {
        this.$nextTick(() => {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        });
      }
    },
    onLogin() {
      this.setProfileStatus({ event: 'login' });
      if (this.$route && this.$route.name === 'disqus-auth') {
        this.loginDisqus()
          .then(() => {
            this.setUseDisqus(true);
            window.close();
          });
      } else {
        const redirect = this.getRedirectPath();
        this.setCurrentPopup();
        if (redirect) {
          this.triggerRedirect(redirect);
        }
      }
    },
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          [CAPTCHA_FIELD]: this.fields.captcha,
          email: this.fields.email,
          password: this.fields.password,
          grant_type: 'password',
          rememberMe: this.fields.rememberMe,
        };
        this.login(payload)
          .then(this.formEnable)
          .then(this.onLogin)
          .catch((error) => {
            this.attempt += 1;
            this.fields.captcha = null;
            this.formHandleErrors(error);
          });
      }
    },
    hideFooter() {
      window.clearTimeout(this.timeout);
      this.timeout = null;
      this.setCurrentPopupOptions({ hideFooter: true });
    },
    showFooter() {
      this.timeout = window.setTimeout(() => {
        this.setCurrentPopupOptions({});
      }, 200);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-login/account-login.js